export default "__VITE_ASSET__DF8ncy7u__"